import { t } from '@lingui/core/macro';
import { FieldNumericController, InputAdornment } from '@luminovo/design-system';
import { Control, FieldValues, Path } from 'react-hook-form';

export function FieldScrapLeader<T extends FieldValues>({
    readOnly,
    control,
    name,
}: {
    readOnly: boolean;
    control: Control<T>;
    name: Path<T>;
}): JSX.Element {
    return (
        <FieldNumericController
            control={control}
            name={name}
            min={0}
            required
            FieldProps={{
                label: t`Setup scrap (leader)`,
                placeholder: t`Setup scrap (leader)`,
                slotProps: {
                    input: {
                        endAdornment: <InputAdornment position="end">{t`Pieces`}</InputAdornment>,
                        readOnly,
                    },
                },
            }}
        />
    );
}
